import { render, staticRenderFns } from "./RecordLabelEditButton.vue?vue&type=template&id=26f8f748"
import script from "./RecordLabelEditButton.vue?vue&type=script&lang=js"
export * from "./RecordLabelEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports